<template>
<div class="trip-detail-wrapper">
  <Error @reload="getDetail()" v-if="networkError" />
  <div class="trip-detail rws" v-else :class="{'has-site': detail.plan_sites.length > 0, 'show-site': showPopup}">
    <div id="map"></div>
    <div class="current-locate" v-show="!expand" @click="locateUser" :class="{'has-popup': showPopup }">
      <img src="../assets/zoom-in-orange.svg" alt="" v-if="showLocateMarker">
      <img src="../assets/zoom-in.svg" alt="" v-else>
    </div>
    <div class="current-marker" ref="marker">
      <div class="circle">
        <div class="arrow"></div>
      </div>
    </div>
    <div class="bottom-content" v-show="!showPopup" :class="{'expand': expand}">
      <div class="bottom-trigger" @click="handleExpand">
        <img src="@/assets/icon-planner-down.svg" class="arrow" />
      </div>
      <!-- 展开编辑模式 -->
      <div class="column-wrapper" v-show="expand">
        <div class="day-column">
          <div class="day"
              :class="{'active': activeDay === index}"
              v-for="(day, index) in tripArray"
              :key="`column-${index}`"
              @click="handleChangeDay(index)">第{{ index + 1 }}天</div>
        </div>
        <div class="site-empty" v-show="showEmpty">亲，你还没有添加任何行程呦～</div>
        <div class="site-list-column" v-show="!showEmpty">
          <div class="card"
               v-for="(item, index) in currentArray"
              :key="item.id"
              ref="card"
              @click="handleDetail(item.site_type, item.site.id, item)">
            <div class="card-img">
              <img v-if="item.site.images && item.site.images.length > 0 || item.site.image" v-lazy="generateObj(`${item.site.images?item.site.images[0].image:item.site.image}?x-oss-process=image/resize,m_fill,h_164,w_164`)" />
              <img v-else src="/image/rws_default.jpg" />
              <div class="tool-box" v-if="currentArray.length > 1">
                <div class="btn"
                     v-if="index !== currentArray.length"
                     @click.stop="handleChangeOrder('down', item.id)">
                    <img src="@/assets/down.png" />
                </div>
                <div class="btn"
                     v-if="index !== 0"
                     @click.stop="handleChangeOrder('up', item.id)">
                  <img src="@/assets/up.png" />
                </div>
              </div>
            </div>
            <div class="card-detail">
              <div class="card-title">{{ item.site.name }}</div>
              <div class="card-time" v-if="item.site_type === 'Site' || item.site_type === 'SiteShop' || item.site_type === 'SiteActivity'">开放时间: {{ item.site.operation_time || '待补充' }}</div>
              <div class="card-time" v-else-if="item.site_type === 'ShowItem'">演出时间: {{ item.site.time || '待补充' }}</div>
              <div class="card-time" v-else-if="item.site_type === 'Merchant'">营业时间: {{ item.site.open || '待补充' }}</div>
              <div class="card-time" v-else-if="item.site_type === 'TravelLog'">包含游览景点: {{ item.site.point_count + '个' || '待补充' }}</div>
              <div class="card-play" v-if="item.site_type === 'Site'">建议游玩: {{ item.site.visiting_time || '待补充' }}</div>
              <div class="card-play" v-else-if="item.site_type === 'ShowItem'">建议游玩: {{ item.site.play_strategy || '待补充' }}</div>
              <div class="card-play" v-else-if="item.site_type === 'TravelLog'">建议游玩: {{ item.site.play_time || '待补充' }}</div>
            </div>
            <div class="card-btns">
              <div class="navigate-btn" @click.stop="handleNavigate(item.site_id)">
                <img src="../assets/trip/nav-orange.svg" />
              </div>
              <img class="delete" @click.stop="handleDelete(index)" src="../assets/trip/delete.svg" />
            </div>
          </div>
        </div>
      </div>
      <div class="trip-wrapper" v-show="!expand">
        <div class="day-wrapper">
          <div class="day"
              :class="{'active': activeDay === index}"
              v-for="(day, index) in tripArray"
              :key="`row-${index}`"
              @click="handleChangeDay(index)">第{{ index + 1 }}天</div>
        </div>
        <div class="site-empty" style="width: 100%" v-show="showEmpty">亲，你还没有添加任何行程呦～</div>
        <div class="swiper-wrap" v-show="!showEmpty">
          <van-swipe :loop="false"
                     :stop-propagation="false"
                     :show-indicators="false"
                     @change="handleSlideChange"
                     ref="slide">
            <van-swipe-item v-for="(item, index) in currentArray" :key="item.id">
              <div class="site-wrapper">
                <div class="card" ref="card" @click="handleDetail(item.site_type, item.site.id, item)">
                  <div class="card-img">
                    <img v-if="item.site.images && item.site.images.length > 0 || item.site.image" v-lazy="generateObj(`${item.site.images?item.site.images[0].image:item.site.image}?x-oss-process=image/resize,m_fill,h_164,w_164`)" />
                    <img v-else src="/image/rws_default.jpg" />
                  </div>
                  <div class="card-detail">
                    <div class="card-title">{{ item.site.name }}</div>
                    <div class="card-time" v-if="item.site_type === 'Site' || item.site_type === 'SiteShop' || item.site_type === 'SiteActivity'">开放时间: {{ item.site.operation_time || '待补充' }}</div>
                    <div class="card-time" v-else-if="item.site_type === 'ShowItem'">演出时间: {{ item.site.time || '待补充' }}</div>
                    <div class="card-time" v-else-if="item.site_type === 'Merchant'">营业时间: {{ item.site.open || '待补充' }}</div>
                    <div class="card-time" v-else-if="item.site_type === 'TravelLog'">包含游览景点: {{ item.site.point_count + '个' || '待补充' }}</div>
                    <div class="card-play" v-if="item.site_type === 'Site'">建议游玩: {{ item.site.visiting_time || '待补充' }}</div>
                    <div class="card-play" v-else-if="item.site_type === 'ShowItem'">建议游玩: {{ item.site.play_strategy || '待补充' }}</div>
                    <div class="card-play" v-else-if="item.site_type === 'TravelLog'">建议游玩: {{ item.site.play_time || '待补充' }}</div>
                  </div>
                  <div class="card-btns">
                    <div class="navigate-btn" @click.stop="handleNavigate(item.site_id)">
                      <img src="../assets/trip/nav-orange.svg" />
                    </div>
                    <img class="delete" @click.stop="handleDelete(index)" src="../assets/trip/delete.svg" />
                  </div>
                </div>
                <div class="route" v-if="item.route && index < currentArray.length - 1">
                  <div class="route-img">
                    <img src="../assets/navigate/car-gray.svg" />
                  </div>
                  <div class="number">{{ item.route.distance }}</div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- <div class="optimize-btn" @click="handleOptimize">
          <img src="../assets/trip/auto-optimize.svg" />
        </div> -->
      </div>
      <div class="add-btn" @click="handleAddSiteList">
        <img src="../assets/trip/add-circle.svg" />
      </div>
    </div>
    <div class="filter-btn" v-show="!expand" :class="{'show-site': showPopup}" @click="handleFilter">
      <img src="../assets/trip/planner-filter.svg" />
    </div>
    <div class="popup-wrapper"
        ref="popup"
        v-show="popupDetail.id && (popupDetail.type === 'Site' || popupDetail.type === 'Merchant' || popupDetail.type === 'ShowItem' || popupDetail.type === 'SiteActivity' || popupDetail.type =='TravelLog')">
      <div class="trip-popup"
          :style="popupDetail.inTrip ? 'padding-left: 9px': 'padding-left: 15px'" :class="{'trip-popup-intrip': popupDetail.type =='TravelLog'}">
        <div class="remove-trip" v-if="popupDetail.inTrip" @click="handleRemoveSite">
          <div v-if="popupDetail.type == 'TravelLog'">
            <div class="img-box">
              <img src="" id="trip-img" class="img1" />
            </div>
            <div class="text">
              <div class="text_name">{{popupDetail.name}}</div>
              <div class="text_label">
                <div v-if="popupDetail.labels.length == 0">待补充</div>
                <div v-for="(item) in popupDetail.labels" :key="item.index">{{item.name}}</div>
              </div>
              <div class="text_time">建议游玩：{{popupDetail.play_time=='' ? '待补充': popupDetail.play_time}}</div>
            </div>
            <img src="../assets/map-nav-orange.svg" class="img2" @click.stop="handleNavigate(popupDetail.id)" />
          </div>
          <div v-else>
            <img src="../assets/delete-circle.svg" />
            <div class="text">从行程中删除</div>
          </div>
        </div>
        <div class="add-trip" v-else @click="handleAddSite">
          <img src="../assets/add.svg" />
          <div class="text">添加到行程</div>
        </div>
        <!-- <div class="set-start" @click="handleSetStart">
          <img src="../assets/start.svg" />
          <div class="text">设置为起点</div>
        </div> -->
      </div>
    </div>
    <!-- 景点信息框 -->
    <div class="info-window" v-if="showPopup" @click="handleDetail(popupDetail.type, popupDetail.id)">
      <div class="info-img">
        <img v-lazy="generateObj(popupDetail.image)" />
      </div>
      <div class="info-detail">
        <div class="info-name">{{ popupDetail.name }}</div>
        <div class="info-labels" v-if="popupDetail.labels && popupDetail.labels.length > 0">
          <div class="label" v-for="item in popupDetail.labels" :key="item">{{ item }}</div>
        </div>
        <div class="info-footer">
          <Score :rating="popupDetail.rating" v-if="popupDetail.rating && (popupDetail.type === 'Site' || popupDetail.type === 'Merchant' ||  popupDetail.type === 'Hotel' || popupDetail.type === 'ShowItem')" />
          <div class="info-price" v-if="popupDetail.best_price">
            <div class="price-text">¥{{ popupDetail.best_price / 100 }}元</div>
            <div class="price-icon">起</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 更多筛选 -->
    <PoiGroups :poiGroups="poiGroups" :active="active" ref="poiGroups" @select="handleSelect" />
  </div>
</div>
</template>

<script>
import {
  getRwsTripDetail,
  getPoiGroups,
  getAllPois,
  rwsEditTrip,
  setAsStart,
  tripOptimize,
  rwsChangeOrder
} from '@/fetch/api'
import moment from 'moment'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import { formatMinutes, GetDistance, pointWithinThere } from '@/utils/index'
import PoiGroups from '@/components/PoiGroups'
import Score from '@/components/Score'
import _ from 'lodash'
import Error from '@/components/Error'
import { Swipe, SwipeItem } from 'vant'
import 'vant/lib/swipe/style'
import 'vant/lib/swipe-item/style'

export default {
  data () {
    return {
      expand: false,
      activeDay: 0,
      detail: {
        plan_sites: []
      },
      noData: false,
      poiGroups: [],
      active: null,
      pois: [],
      showPopup: false,
      popupDetail: {},
      header: {},
      isUserAllowedGeoLocation: false,
      inThere: false,
      startGeo: {},
      scrollLeft: 0,
      tripArray: [],
      currentArray: [],
      networkError: false,
      showLocateMarker: false,
      showEmpty: false
    }
  },
  components: {
    PoiGroups,
    Score,
    Error,
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem
  },
  computed: {
    siteId () {
      return this.$store.state.siteId
    }
  },
  created () {
    this.bearing = 0
    // document.title = '行程详情'
    this.toast = this.$createToast({
      time: 0,
      txt: '加载中...',
      mask: true
    })
    this.toast.show()
    this.Android = window.navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    this.startUpdateLocation()
  },
  mounted () {
    mapboxgl.accessToken = 'pk.eyJ1IjoicHVzaGlhbiIsImEiOiJjaXdyaXptNDAweG1rMm90YmRnZHl0dDFpIn0.9kBN2eXNRe3uZ9VMoMhfhg'

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/pushian/cj8313byya3lp2so6gvh49efn',
      center: this.siteId === '245' ? [103.82740222, 1.2527583] : this.siteId === '129' ? [103.861601, 1.340794] : [10.372776, 51.083226],
      zoom: 12.6
      // bounds: new mapboxgl.LngLatBounds([103.852152, 1.260704], [103.804682, 1.267034])
    })

    this.map.on('click', () => {
      this.showPopup = false
    })

    this.map.on('load', () => {
      this.getPois()
      this.getDetail()
      this.getPoiList()
    })

    // this.map.on('dragPan', () => {
    //   this.locateMode = false
    // })

    // 根据zoom设置透明度
    // this.map.on('zoomend', () => {
    //   this.changeOpacity()
    // })

    this.map.on('rotate', res => {
      const alpha = this.map.getBearing()
      console.log('=======rotateend', alpha)
      this.bearing = alpha
      // // console.log('停止旋转')
      // const marker = document.querySelector('.current-marker .circle')
      // marker.style.transform = `rotateZ(${this.markerBearning - this.bearing}deg)`
    })
  },
  methods: {
    generateObj (src) {
      return {
        src,
        error: '/image/rws_default.jpg',
        loading: '/image/loading-img.jpg'
      }
    },
    getDetail () {
      const query = this.$route.query
      getRwsTripDetail(query.id, {
        'X-CLIENT-ID': query.clientId,
        'X-ACCESS-TOKEN': query.token,
        'X-USER-ID': query.userId
      }).then(res => {
        this.toast.hide()
        this.header = {
          'X-CLIENT-ID': query.clientId,
          'X-ACCESS-TOKEN': query.token,
          'X-USER-ID': query.userId
        }
        this.networkError = false
        this.processData(res.travel_plan)
      }).catch(err => {
        this.toast.hide()
        console.log(err)
        this.networkError = true
      })
    },
    // 处理行程数据
    processData (trip, type) {
      // 按日期分组
      const array = []
      const endDate = moment(trip.end_time)
      const days = endDate.diff(trip.start_time, 'd') + 1
      const fmtStart = moment(trip.start_time).format('YYYY/MM/DD')
      const fmtEnd = moment(trip.end_time).format('YYYY/MM/DD')
      for (let i = 0; i < days; i++) {
        array.push({
          date: moment(trip.start_time).add(i, 'd').format('YYYY/MM/DD'),
          plan_sites: []
        })
      }
      for (let i = 0; i < trip.plan_sites.length; i++) {
        const planSite = trip.plan_sites[i]
        const date = moment(planSite.date).format('YYYY/MM/DD')
        const target = array.find(item => item.date && item.date === date)
        planSite.site.visiting_time = formatMinutes(planSite.site.visiting_time)
        if (target) {
          let distance = this.siteId === '33' ? Math.round(Math.random() * 20 + 70) : Math.round(Math.random() * 5 + 5)
          planSite.route = {
            ...trip.routes[i],
            distance: formatMinutes(distance)
          }
          target.plan_sites.push(planSite)
        }
      }
      this.detail = { ...trip, start_time: fmtStart, end_time: fmtEnd }
      this.tripArray = array
      if (!type) {
        this.currentArray = array[0].plan_sites
        this.showEmpty = array[0].plan_sites.length === 0
      } else {
        this.currentArray = array[this.activeDay].plan_sites
        this.showEmpty = array[this.activeDay].plan_sites.length === 0
      }
      this.$nextTick(() => {
        this.drawTripRoute()
      })
    },
    // 在地图上绘制行程路线
    drawTripRoute () {
      if (this.oldLayer) {
        this.map.removeLayer(this.oldLayer)
        this.map.removeSource(this.oldLayer)
      }
      if (this.currentArray.length === 0) {
        this.oldLayer = ''
        // 删除旧的marker
        if (this.markers && this.markers.length > 0) {
          this.markers.forEach(item => {
            item.remove()
          })
        }
        return
      }
      const coordinates = this.currentArray.map(item => {
          return [item.site.lon, item.site.lat]
      })
      this.map.addLayer({
        'id': 'route',
        'type': 'line',
        'source': {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'geometry': {
              'type': 'LineString',
              'coordinates': coordinates
            }
          }
        },
        'layout': {
          'line-cap': 'round',
          'line-join': 'round'
        },
        'paint': {
          'line-width': 3,
          'line-color': 'rgba(0, 70, 70, 0.7)'
        }
      })
      this.oldLayer = 'route'
      this.fixMapBounds()
      // this.drawSites()
      this.drawMarker()
    },
    fixMapBounds () {
      if (this.currentArray.length === 0) return
      const bounds = this.calcLonLat(this.currentArray)
      this.map.fitBounds(bounds, {
        padding: {
          top: 60,
          bottom: this.expand ? 480 : 180,
          left: 60,
          right: 60
        }
      })
    },
    // 计算[sw, ne]
    calcLonLat (array) {
      let minLon = array[0].site.lon
      let minLat = array[0].site.lat
      let maxLon = array[0].site.lon
      let maxLat = array[0].site.lat
      array.forEach(item => {
        if (item.site.lon < minLon) {
          minLon = item.site.lon
        } else if (item.site.lon > maxLon) {
          maxLon = item.site.lon
        }
        if (item.site.lat < minLat) {
          minLat = item.site.lat
        } else if (item.site.lat > maxLat) {
          maxLat = item.site.lat
        }
      })
      return [[minLon, minLat], [maxLon, maxLat]]
    },
    // 为地图添加image
    handleMapImage () {
      return new Promise((resolve, reject) => {
        if (this.map.hasImage('marker')) {
          resolve()
        } else {
          this.map.loadImage('/image/map/marker-bg.png', (error, image) => {
            if (error) {
              reject(error)
            } else {
              this.map.addImage('marker', image)
              resolve()
            }
          })
        }
      })
    },
    // 绘制plan site
    drawSites () {
      this.handleMapImage().then(res => {
        if (this.oldSite) {
          this.map.removeLayer(this.oldSite)
          this.map.removeSource(this.oldSite)
        }
        const features = this.detail.plan_sites.map((item, index) => {
          return {
            type: 'Feature',
            properties: {
              index: index + 1,
              planSite: item,
              icon: 'hotel'
            },
            geometry: {
              type: 'Point',
              coordinates: [item.site.lon, item.site.lat]
            }
          }
        })

        this.map.addLayer({
          id: 'site',
          type: 'symbol',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: features
            }
          },
          layout: {
            'icon-image': 'marker',
            'icon-size': 0.5,
            'text-field': ['get', 'index'],
            'text-size': 12,
            'text-offset': [0, -0.2],
            'icon-allow-overlap': true
          },
          paint: {
            'text-color': '#009098',
            'text-halo-color': '#009098',
            'text-halo-width': 0.2
          },
          filter: ['>=', 'index', 0]
        })
        this.oldSite = 'site'
        this.map.on('click', 'site', e => {
          console.log('点击了layer', e.features)
          const feature = e.features[0]
          const lngLat = e.lngLat
          const planSite = JSON.parse(feature.properties.planSite)
          this.popupDetail = {
            ...planSite.site,
            type: planSite.site_type,
            inTrip: true,
            planSiteId: planSite.id
          }
          this.$nextTick(() => {
            this.initPopup(feature, lngLat)
          })
        })
      })
    },
    // 添加起点终点icon
    drawMarker () {
      // 删除旧的marker
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(item => {
          item.remove()
        })
      }
      let markers = []
      this.currentArray.forEach((item, current) => {
        const el = document.createElement('div')
        el.className = 'marker'
        el.innerText = current + 1
        el.style.width = '24px'
        el.style.height = '24px'
        el.style.borderRadius = '50%'
        el.style.border = '3px solid #009098'
        el.style.backgroundColor = '#ffffff'
        el.style.shadow = '0 2px 4px 0 rgba(0, 0, 0, 0.37)'
        el.style.display = 'flex'
        el.style.alignItems = 'center'
        el.style.justifyContent = 'center'
        el.style.fontSize = '12px'
        el.style.color = '#009098'
        el.addEventListener('click', (e) => {
          e.stopPropagation()
          this.popupDetail = {
            ...item.site,
            type: item.site_type,
            inTrip: true,
            planSiteId: item.id
          }
          console.log('marker 触发的弹窗', item.site)
          this.showPopup = false
          this.$nextTick(() => {
            this.initPopup({
              geometry: {
                coordinates: [item.site.lon, item.site.lat]
              }
            }, { lon: item.site.lon, lat: item.site.lat })
            this.$refs.slide.swipeTo(current)
          })
        })
        // add marker to map
        const marker = new mapboxgl.Marker(el)
          .setLngLat([item.site.lon, item.site.lat])
          .addTo(this.map)
        markers.push(marker)
      })
      this.markers = markers
      // console.log(this.currentArray[0].site)
      // let temp1 = [this.currentArray[0].site.lon,this.currentArray[0].site.lat]
      // this.map.flyTo({ center: temp1})
    },
    calcData (zoom) {
      let minSize = 0.26
      let maxSize = 0.4
      let rate = 0.04
      if (this.siteId === '33') {
        minSize = 0.36
        maxSize = 0.5
        rate = 0.08
      }
      let opacity = zoom * 0.1 - 0.5
      let fontSize = zoom >= 15 ? (zoom - 15) * 0.8 + 8 : 0
      let fontOpacity = zoom >= 15 ? (zoom - 15) * 0.12 + 0.4 : 0
      let size = zoom * rate - 0.2

      if (size < minSize) {
        size = minSize
      } else if (size > maxSize) {
        size = maxSize
      }
      if (opacity > 1) {
        opacity = 1
      } else if (opacity < 0.7) {
        opacity = 0.7
      }
      if (fontSize > 12) fontSize = 12
      if (fontOpacity > 1) fontOpacity = 1
      const returnData = {
        opacity,
        fontOpacity,
        size,
        fontSize
      }
      return returnData
    },
    // 修改layer opactiy
    changeOpacity () {
      const zoom = this.map.getZoom()
      const data = this.calcData(zoom)
      for (let key in this.pois) {
        if (this.map.getLayer(key)) {
          this.map.setPaintProperty(key, 'icon-opacity', data.opacity).setLayoutProperty(key, 'icon-size', data.size)

          if (zoom > 15) { // 显示文字
            this.map.setPaintProperty(key, 'text-opacity', data.fontOpacity).setLayoutProperty(key, 'text-size', data.fontSize)
          } else {
            this.map.setPaintProperty(key, 'text-opacity', 0)
          }
        }
      }
    },
    handleFilter () {
      this.$refs.poiGroups.show()
    },
    // 获取poiGroups
    getPois () {
      getPoiGroups(this.siteId).then(res => {
        this.poiGroups = res.poi_groups.sort((a, b) => {
          return b.rank - a.rank
        })
      })
    },
    // 获取所有的景点
    getPoiList () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      getAllPois(this.siteId).then(res => {
        // 处理poi。根据类型和groupId分组 
        const obj = _.groupBy(res.pois, item => `${item.type}-${item.poi_group_id}`)
        this.pois = obj
        this.$nextTick(() => {
          let promiseArray = []
          for (let key in obj) {
            promiseArray.push(this.loadImages({
              id: key,
              image_url: obj[key][0].poi_group_icon || '/image/map/SitePoint.png'
            }))
          }
          Promise.all(promiseArray).then(resArray => {
            this.renderLayer(obj)
          })
        })
      })
    },
    // 加载所有图片
    loadImages (poiGroup) {
      return new Promise((resolve, reject) => {
        this.map.loadImage(poiGroup.image_url, (error, image) => {
          console.log(error, image)
          if (error) {
            reject(error)
          } else {
            this.map.addImage(poiGroup.id, image)
            resolve()
          }
        })
      })
    },
    // 计算四个表达式
    calcExpression () {
      let iconSize = [
        'interpolate', ['linear'], ['zoom'],
        9, 0.26,
        18, 0.4
      ]
      let iconOpacity = [
        'interpolate', ['linear'], ['zoom'],
        9, 0.4,
        12.6, 1,
      ]
      if (this.siteId === '129') { // 新加坡
        iconSize = [
          'interpolate', ['linear'], ['zoom'],
          9, 0.26,
          18, 0.46
        ]
        iconOpacity = [
          'interpolate', ['linear'], ['zoom'],
          9, 0.4,
          18, 1
        ]
      } else if (this.siteId === '33') { // 德国
        iconSize = [
          'interpolate', ['linear'], ['zoom'],
          5, 0.24,
          18, 0.46
        ]
        iconOpacity = [
          'interpolate', ['linear'], ['zoom'],
          5, 0.4,
          18, 1
        ]
      }
      return { iconSize, iconOpacity }
    },
    // 根据type渲染layer
    renderLayer (obj) {
      let array = []
      for (let key in obj) {
        array.push({
          name: key,
          pois: obj[key]
        })
      }
      const sortedArray = _.cloneDeep(array).sort((a, b) => {
        const aType = a.name.split('-')[0]
        const bType = b.name.split('-')[0]
        if (aType === 'SiteStation' || aType === 'SitePoint' || aType === 'Toilet') {
          return -1
        }
        if (bType === 'SiteStation' || bType === 'SitePoint' || bType === 'Toilet') {
          return 1
        }
      })

      let zoom = 12.6
      if (this.siteId === '245') {
          zoom = 14.5
      } else if (this.siteId === '129') {
          zoom = 9
      } else if (this.siteId === '33') {
          zoom = 5
      } else {
          zoom = 12.6
      }
      const expression = this.calcExpression()
      sortedArray.forEach(poiGroup => {
        const features = poiGroup.pois.map(item => {
          const name = item.name.split('\r\n').join('')
          return {
            type: 'Feature',
            properties: {
              poi: item,
              icon: poiGroup.name,
              name: name
            },
            geometry: {
              type: 'Point',
              coordinates: [item.lon, item.lat]
            }
          }
        })
        this.map.addLayer({
          id: poiGroup.name,
          type: 'symbol',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: features
            }
          },
          layout: {
            'icon-image': poiGroup.name,
            'icon-size': expression.iconSize,
            'text-field': ['get', 'name'],
            'text-anchor': 'left',
            'text-justify': 'center',
            'text-offset': [1.5, 0],
            'text-size': [
              'interpolate', ['linear'], ['zoom'],
              13, 0,
              14, 8,
              20, 12
            ]
          },
          paint: {
            'text-color': '#222125',
            'icon-opacity': expression.iconOpacity,
            'text-opacity': [
              'interpolate', ['linear'], ['zoom'],
              14, 0,
              15, 0.5,
              20, 1
            ]
          }
        })

        this.map.on('click', poiGroup.name, e => {
          console.log('点击了layer', e.features)
          const feature = e.features[0]
          const lngLat = e.lngLat
          const poi = JSON.parse(feature.properties.poi)
          const planSite = this.detail.plan_sites.find(item => item.site.id === poi.id && item.site_type === poi.type)
          this.popupDetail = {
            ...poi,
            type: poiGroup.name.split('-')[0],
            inTrip: !!planSite,
            planSiteId: planSite ? planSite.id : ''
          }
          if (!planSite) {
            this.showPopup = true
          }
          this.$nextTick(() => {
            this.initPopup(feature, lngLat)
          })
        })
      })
    },
    // 点击查看详情
    handleDetail (type, id, item) {
      let path = ''
      if (type === 'Site') {
        path = `/packageTourGuide/site/siteDetailPage/index?id=${id}&from=trip&tripId=${this.$route.query.id}&tripDate=${this.tripArray[this.activeDay].date}`
      } else if (type === 'ShowItem') {
        path = `/packageTourGuide/show/showDetailPage/index?id=${id}&from=trip&tripId=${this.$route.query.id}&tripDate=${this.tripArray[this.activeDay].date}`
      } else if (type === 'Merchant') {
        path = `/packageTourGuide/otherPOI/restaurantDetailPage/index?id=${id}&from=trip&tripId=${this.$route.query.id}&tripDate=${this.tripArray[this.activeDay].date}`
      } else if (type === 'SiteActivity') {
        path = `/packageTourGuide/site/eventDetailPage/index?id=${id}&from=trip&tripId=${this.$route.query.id}&tripDate=${this.tripArray[this.activeDay].date}`
      } else if (type === 'TravelLog') {
        let date = moment(item.route.date).format('YYYY/MM/DD')
        path = `/packageItinerary/pages/playDetail/index?id=${id}&plan_site_id=${item.site_id}&type=CityWalk&from=trip&tripId=${this.detail.id}&tripDate=${date}`
      }
      // else if (type === 'Hotel') {
      //   path = `/packageScenic/pages/hotelDetail/index?id=${id}`
      // } else if (type === 'SiteShop') {
      //   path = `/packageScenic/pages/mallDetail/index?id=${id}`
      // } else if (type === 'PoiPromotion') {
      //   path = `/packageScenic/pages/promotionDetail/index?id=${id}`
      // }
      console.log('导航的地址', path)
      window.wx.miniProgram.navigateTo({
        url: path
      })
    },
    // 选择poiGroup
    handleSelect (index) {
      this.active = index
      this.showPopup = false
      if (index === -1) {
        for (let key in this.pois) {
          this.map.setLayoutProperty(key, 'visibility', 'visible')
        }
      } else {
        const selectedPoiGroup = this.poiGroups[index]
        const typeName = selectedPoiGroup.poi_type.split('_').map(item => {
          const type = item.slice(0, 1).toUpperCase() + item.slice(1)
          return type
        }).join('')
        console.log(typeName)
        for (let key in this.pois) {
          if (key === `${typeName}-${selectedPoiGroup.id}`) {
            this.map.setLayoutProperty(key, 'visibility', 'visible')
          } else {
            this.map.setLayoutProperty(key, 'visibility', 'none')
          }
        }
      }
    },
    // 导航
    handleNavigate (poi_id) {
      let index = 0
      for(let i=0;i<this.detail.plan_sites.length;i++){
        if(this.detail.plan_sites[i].site_id == poi_id){
          index = i;
        }
      }
      console.log(this.detail.plan_sites)
      const planSite = this.detail.plan_sites[index]
      console.log(parseFloat(planSite.site.lon), parseFloat(planSite.site.lat), planSite.site.name, planSite.site_type, planSite.site.id)
      // [start_lon, start_lat, start_name, start_type, start_id, end_lon, end_lat, end_name, end_type, end_id, longitude, latitude]
      const routeArray = ['', '', '', '', '', parseFloat(planSite.site.lon), parseFloat(planSite.site.lat), planSite.site.name, planSite.site_type, planSite.site.id]
      window.wx.miniProgram.navigateTo({
        url: `/packageTourGuide/map/navigationMapPage/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
      })
    },
    handleNavigateRoute (index) {
      const startPlanSite = this.detail.plan_sites[index]
      const route = startPlanSite.route
      const endPlanSite = this.detail.plan_sites.find(item => item.id === route.end_id)
      const routeArray = [route.start_lon, route.start_lat, route.start_name, startPlanSite.site_type, startPlanSite.site.id, route.end_lon, route.end_lat, route.end_name, endPlanSite.site_type, endPlanSite.site.id]
      console.log(routeArray)
      window.wx.miniProgram.navigateTo({
        url: `/packageScenic/pages/navigateWeb/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
      })
    },
    // 删除景点
    handleDelete (index) {
      const planSite = this.currentArray[index]
      if (this.popup) {
        this.popup.remove()
      }
      this.handleDeleteModal(planSite.site.name, planSite.id)
    },
    // 显示弹窗
    initPopup (feature, lngLat) {
      console.log('初始化弹窗', feature, lngLat)
      if (this.popupDetail.type !== 'Site' && this.popupDetail.type !== 'Merchant' && this.popupDetail.type !== 'ShowItem' && this.popupDetail.type !== 'SiteActivity' && this.popupDetail.type !== 'TravelLog') {
        return
      }
      console.log('要显示弹窗')
      const coordinates = feature.geometry.coordinates.slice()

      while (Math.abs(lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += lngLat.lng > coordinates[0] ? 360 : -360
      }
      console.log(coordinates)
      if (this.popup) {
        this.popup.remove()
      }
      this.popup = new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setDOMContent(this.$refs.popup)
        .addTo(this.map)

      this.map.flyTo({ center: feature.geometry.coordinates, zoom: 16 })

      if(this.popupDetail.type == 'TravelLog'){
        var temp = document.getElementsByClassName("mapboxgl-popup-tip")[0];
        temp.style.borderTopColor = "white";
        temp.style.borderBottom = '0.266667rem solid transparent';
        var img = document.getElementById("trip-img");
        img.setAttribute("src",this.popupDetail.image);
        img.setAttribute("onerror","this.src='/image/rws_default.jpg'");
      }
    },
    handleDeleteModal (name, id) {
      this.$createDialog({
        type: 'confirm',
        content: `确定将“${name}”从行程中删除吗?`,
        cancelBtn: {
          text: '删除',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        confirmBtn: {
          text: '不舍得',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          // 点击不舍得触发，其实是取消
        },
        onCancel: () => {
          this.toast = this.$createToast({
            time: 0,
            txt: '加载中...',
            mask: true
          })
          this.toast.show()
          rwsEditTrip(this.detail.id, {
            travel_plan: {
              plan_sites_attributes: [
                {
                  id: id,
                  _destroy: true
                }
              ]
            }
          }, this.header).then(res => {
            this.toast.hide()
            this.processData(res.travel_plan, 'delete')
          })
        }
      }).show()
    },
    // 添加到行程
    handleAddSite () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      this.popup.remove()
      this.showPopup = false
      rwsEditTrip(this.detail.id, {
        travel_plan: {
          plan_sites_attributes: [{
            site_id: this.popupDetail.id,
            date: this.tripArray[this.activeDay].date,
            site_type: this.popupDetail.type
          }]
        }
      }, this.header).then(res => {
        this.toast.hide()
        this.processData(res.travel_plan, 'add')
      })
    },
    // 从行程中删除/跳转到导览路线详情
    handleRemoveSite () {
        if(this.popupDetail.type == 'TravelLog'){
          const query1 = this.$route.query;
          console.log("我点击了导览路线详情")
          let query = {
            id: this.popupDetail.id,
            from: 'CityWalk',
            clientId: query1.clientId,
            appKey: query1.appKey,
            token: query1.token,
            userId: query1.userId,
            siteId: query1.siteId
          }
          this.$router.push({path:'/',query})
        }else{
          this.showPopup = false
          this.popup.remove()
          this.handleDeleteModal(this.popupDetail.name, this.popupDetail.planSiteId)
        }
    },
    // 设置喂起点
    handleSetStart () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      this.showPopup = false
      this.popup.remove()
      let params = {}
      if (this.popupDetail.inTrip) {
        params.plan_site_id = this.popupDetail.planSiteId
      } else {
        params.site_id = this.popupDetail.id
        params.site_type = this.popupDetail.type
      }
      setAsStart(this.detail.id, params, this.header).then(res => {
        this.toast.hide()
        this.processData(res.travel_plan)
      })
    },
    // 优化行程
    handleOptimize () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      tripOptimize(this.detail.id, this.header).then(res => {
        this.toast.hide()
        this.processData(res.travel_plan)
      })
    },
    handleScroll (e) {
      this.scrollLeft = e.x
    },
    // 添加景区到行程
    handleAddSiteList () {
      window.wx.miniProgram.navigateTo({
        url: `/packageTourGuide/pages/listPage/index?from=trip&travel_plan_id=${this.detail.id}&date=${this.tripArray[this.activeDay].date}`
      })
    },
    // 切换行程日期
    handleChangeDay (index) {
      this.activeDay = index
      this.currentArray = []
      this.currentArray = this.tripArray[index].plan_sites
      this.showEmpty = this.tripArray[index].plan_sites.length === 0
      if (this.popup) {
        this.popup.remove()
      }
      this.$nextTick(() => {
        this.drawTripRoute()
      })
    },
    // 获取角度、位置信息
    startUpdateLocation () {
      if (this.Android) {
        window.addEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
      } else {
        window.addEventListener('deviceorientation', this.handleOrientation)
      }
      this.watchId = window.navigator.geolocation.watchPosition((res) => {
        this.isUserAllowedGeoLocation = true
        const longitude = res.coords.longitude
        const latitude = res.coords.latitude
        // console.log(longitude, latitude)
        if (longitude) {
          this.startGeo = {
            lon: longitude,
            lat: latitude
          }
          if (this.currentMarker) {
            this.currentMarker.setLngLat([longitude, latitude])
            this.currentMarker.addTo(this.map)
          }
        }
        this.inThere = pointWithinThere(longitude, latitude)
      }, err => {
        this.isUserAllowedGeoLocation = false
        console.log(err)
      }, {timeout: 20000, enableHighAccuracy: true})
    },
    handleOrientation (res) {
      const alpha = res.webkitCompassHeading
      // console.log('获取到的数据', alpha)
      // alert(`收到数据alpha: ${alpha}`)
      this.alpha = alpha
      this.deviceOrientationHandler(alpha)
    },
    handleOrientationAbsolute (res) {
      const alpha = 360 - res.alpha
      // console.log('获取到的数据', alpha)
      // alert(`收到数据alpha: ${alpha}`)
      this.alpha = alpha
      this.deviceOrientationHandler(alpha)
    },
    deviceOrientationHandler (alpha) {
      // console.log('收到的角度', alpha)
      if (!this.currentMarker) return
      console.log('有marker')
      const marker = document.querySelector('.current-marker .circle')
      // console.log('当前的marker', marker)
      marker.style.transform = `rotateZ(${alpha - this.bearing}deg)`
    },
    // 添加当前位置marker
    drawCurrentMarker (longitude, latitude) {
      // add marker to map
      this.showLocateMarker = true
      const marker = new mapboxgl.Marker(this.$refs.marker)
        .setLngLat([longitude, latitude])
        .addTo(this.map)
      this.currentMarker = marker
    },
    // 点击按钮定位到当前位置
    locateUser() {
      if (!this.isUserAllowedGeoLocation) {
        this.$createDialog({
          type: 'alert',
          confirmBtn: {
              text: this.$t('common.confirm')
          },
          content: this.$t('navigate.plzAllowLocation')
        }).show()
        return
      }
      if (!this.inThere) {
        let text = ''
        if (this.siteId === '245') {
          text = '亲，你的当前位置不在RWS'
        } else if (this.siteId === '129') {
          text = '亲，你的当前位置不在新加坡'
        }  else if (this.siteId === '33') {
          text = '亲，你的当前位置不在德国'
        } else {
          text = '亲，你的当前位置不在圣淘沙'
        }
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: text
        })
        this.toast.show()
        return
      }
      if (this.startGeo && this.startGeo.lon) {
        if (!this.currentMarker) {
          this.drawCurrentMarker(this.startGeo.lon, this.startGeo.lat)
        }
        this.map.panTo([this.startGeo.lon, this.startGeo.lat])
      } else {
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: '未获取到你的位置，请稍后重试！'
        })
        this.toast.show()
      }
    },
    handleSlideChange (index) {
      const currentPoi = this.currentArray[index]
      this.popupDetail = {
        ...currentPoi.site,
        type: currentPoi.site_type,
        inTrip: true,
        planSiteId: currentPoi.id
      }
      this.showPopup = false
      this.$nextTick(() => {
        this.initPopup({
          geometry: {
            coordinates: [currentPoi.site.lon, currentPoi.site.lat]
          }
        }, { lon: currentPoi.site.lon, lat: currentPoi.site.lat })
      })
    },
    handleExpand () {
      this.expand = !this.expand
      this.fixMapBounds()
      this.$nextTick(() => {
        if (!this.expand) {
          this.$refs.slide.resize()
        }
      })
    },
    // 上下调整顺序
    handleChangeOrder (type, id) {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中...',
        mask: true
      })
      this.toast.show()
      rwsChangeOrder(this.detail.id, {
        move: type,
        plan_site_id: id,
      }, this.header).then(res => {
        this.toast.hide()
        this.processData(res.travel_plan,'changeOrder')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#map {
  height: 100vh;
}
.trip-detail-wrapper {
	padding-bottom: 40px;
}
.trip-detail {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.scroll-wrapper {
  height: 84px;
}
.site-wrapper {
  display: flex;
  height: 84px;
}

.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  width: 279px;
  height: 82px;
  padding-right: 8px;

  &-img {
    width: 82px;
    height: 82px;
    flex-shrink: 0;
    background-color: #ccc;
    position: relative;

    img {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    .tool-box {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(34, 33, 37, 0.75);
      display: flex;
      justify-content: center;
      z-index: 2;
      height: 22px;
    }

    .btn {
      padding: 2px;
      &:nth-child(2) {
        margin-left: 21px;
      }

      img {
        width: 15px;
        height: 15px;
        display: block;
      }
    }
  }

  &-detail {
    padding-left: 12px;
    flex: 1;
  }

  &-title {
    font-size: 16px;
    line-height: 22px;
    font-weight: bold;
    font-family: "Montserrat";
    color: #3d3d3d;
    margin-bottom: 9px;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &-time,
  &-play {
    font-size: 12px;
    line-height: 17px;
    margin-top: 4px;
    color: #888888;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &-btns {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .navigate-btn {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #f8a909;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;

      img {
        width: 16px;
        height: 16px;
        display: block;
      }
    }
  }
}

.route {
  width: 49px;
  font-size: 12px;
  color: #888888;
  text-align: center;
  align-self: center;

  img {
    width: 16px;
    height: 13px;
    display: block;
    margin: 0 auto;
  }

  .number {
    line-height: 17px;
    margin-top: 10px;
    white-space: initial;
    padding: 0 10px;
  }
}
.optimize-btn {
  position: absolute;
  left: 18px;
  top: -20px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.22);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 21px;
    height: 21px;
    display: block;
  }
}

.day-wrapper {
  display: flex;
  margin-bottom: 12px;
  width: 100%;
  overflow: auto;

}
.day {
  font-size: 14px;
  color: #888888;
  padding: 0 8px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  border: solid 1px #888888;
  margin-right: 16px;
  flex-shrink: 0;
  white-space: nowrap;

  &.active {
    background-color: #f8a909;
    border-color: #f8a909;
    color: #ffffff;
  }
}

.add-btn {
  position: absolute;
  top: -20px;
  right: 14px;
  margin-left: -60px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 38px;
    height: 38px;
    display: block;
    margin-right: 4px;
  }

  span {
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
  }
}

.filter-btn {
  position: absolute;
  bottom: 15px;
  right: 17px;
  bottom: 212px;
  margin-bottom: env(safe-area-inset-bottom);
  z-index: 30;

  &.show-site {
    bottom: 106px;
  }

  img {
    width: 41px;
    height: 41px;
    display: block;
  }
}

.info-window {
  position: absolute;
  bottom: 12px;
  left: 12px;
  right: 12px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  z-index: 30;
  margin-bottom: env(safe-area-inset-bottom);

  .info-img {
    width: 82px;
    height: 82px;
    background-color: #cccccc;
    flex-shrink: 0;

    img {
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  .info-detail {
    padding: 0 12px;
    flex: 1;
  }

  .info-name {
    font-size: 16px;
    color: #3d3d3d;
    line-height: 22px;
    font-weight: bold;
    font-family: "Montserrat";
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
  }

  .info-labels {
    display: flex;
    align-items: center;

    .label {
      padding: 0 4px;
      font-size: 10px;
      line-height: 14px;
      font-size: 10px;
      color: #ed9107;
      border: 1px solid #ed9107;
      border-radius: 2px;
      margin-right: 5px;
      margin-top: 3px;
    }
  }

  .info-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 11px;
  }

  .info-price {
    display: flex;
    align-items: baseline;
    color: #60c2ed;

    .price-text {
      font-size: 14px;
      font-weight: bold;
      font-family: "Montserrat";
    }

    .price-icon {
      font-size: 12px;
      font-weight: bold;
      font-family: "Montserrat";
    }
  }
}

.site-empty {
  font-size: 14px;
  width: 279px;
  line-height: 84px;
  color: #888888;
  text-align: center;
  height: 84px;
}

.trip-detail .mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip{
  color: red;
  //border-top-color:red !important;
}

.trip-popup {
  background-color: rgba(38, 39, 40, 0.8);
  border-radius: 4px;
  width: 114px;
  padding-left: 10px;
  position: relative;


  // &:after {
  //   content: '';
  //   width: 100%;
  //   height: 1px;
  //   background-color: rgba(255, 255, 255, 0.3);
  //   position: absolute;
  //   top: 50%;
  //   left: 0;
  // }

  .add-trip,
  .remove-trip>div,
  .set-start {
    display: flex;
    align-items: center;
    height: 42px;
  }

  .remove-trip>div{
    position:relative;
  }

  .text {
    font-size: 12px;
    position: relative;
    top: 1px;
    color: #ffffff;
    display: block;
  }

  .text>.text_name{
    height:21px;
    font-size:15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .text>.text_label{
    margin-bottom:12px;
    color:#f8a909;
  }

  .text>.text_label>div{
    padding: 0 4px;
    margin-top:5px;
    margin-right:4px;
    display:inline-block;
    border-radius: 2px;
    border: solid 0.5px #f8a909;
  }

  .text>.text_time{
    color:#666666;
  }

  .add-trip img {
    width: 16px;
    height: 15px;
    display: block;
    margin-right: 7px;
  }

  .remove-trip>div>img {
    width: 17px;
    height: 17px;
    display: block;
    margin-right: 6px;
  }

  .remove-trip>div>.img-box {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    display: block;
    margin-right: 12px;
  }

  .remove-trip>div>.img-box>.img1 {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .remove-trip>div>.img2 {
    width:32px;
    height:32px;
    position:absolute;
    bottom:0;
    right:0;
    margin-right:0;
  }

  .set-start img {
    width: 17px;
    height: 19px;
    display: block;
    margin-right: 6px;
  }
}

.trip-popup-intrip {
  background-color: white;
  width: 308px;
  box-shadow: 0 2px 6px 0 rgba(19, 15, 3, 0.2);
  color:#171717;
  //background-image: url(as../sents/combined-shape.svg)
  padding: 13px 12px;

  .remove-trip>div{
    height:auto
  }

  .text {
    font-size: 10px;
    width:192px;
    padding-top: 6px;
    color:#171717;
  }
}

.current-locate {
  position: absolute;
  left: 18px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 212px;
  margin-bottom: env(safe-area-inset-bottom);
  z-index: 30;
  &.has-popup {
    bottom: 108px;
  }

  img {
    width: 25px;
    height: 26px;
  }
}
.current-marker {
  z-index: 20;
  transform: translate(-9999px, -9999px);
  .circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: url('/image/navigate/current-marker.svg') no-repeat center center;
    z-index: 2;
    position: relative;
    background-size: 100% 100%;
  }

  .arrow {
    position: absolute;
    border: 5px solid transparent;
    border-bottom: 5px solid #00AAE5;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    margin-bottom: -2px;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }
}

.bottom-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.85);
  padding: 0 12px 12px;
  margin-bottom: env(safe-area-inset-bottom);
  z-index: 30;

  .arrow {
    display: block;
    margin: 0 auto;
    width: 32px;
    transform: rotateZ(180deg);
    transition: transform 0.2s ease-out;
  }

  &.expand {
    .arrow {
      transform: rotateZ(0);
    }
  }

  .day-column,
  .site-list-column {
    height: 439px;
    overflow: auto;
  }
}

.swiper-wrap {
  width: 328px;
  overflow: visible;
}
.van-swipe {
  overflow: visible;
}
.van-swipe-item {
  overflow: visible;
}

.column-wrapper {
  display: flex;
  padding-bottom: env(safe-area-inset-bottom);

  .day {
    margin-right: 15px;

    &:not(:last-child) {
      margin-bottom: 18px;
    }
  }

  .card {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
}
</style>
